module.exports = __webpack_public_path__ + "img/icon-error.93e6d8b2.svg";